import { render, staticRenderFns } from "./actions.vue?vue&type=template&id=d771c61e&scoped=true"
import script from "./actions.vue?vue&type=script&lang=js"
export * from "./actions.vue?vue&type=script&lang=js"
import style0 from "./actions.vue?vue&type=style&index=0&id=d771c61e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d771c61e",
  null
  
)

export default component.exports